module.exports = __webpack_public_path__ + "static/media/peso.e5a6dc18.png";